import { CalendarEventRef, ID } from '@griply/types';

export type ExternalCalendarEventRefInput = {
  eventId?: ID;
  connectionId?: ID;
  calendarId?: ID;
};

// One rule for both platforms: an older backend omits the connection/calendar pair, and
// without it the event cannot be resolved back to a calendar. Callers treat null as
// "fall back to the provider url" rather than opening a detail surface that cannot load.
export const getExternalCalendarEventRef = ({
  eventId,
  connectionId,
  calendarId,
}: ExternalCalendarEventRefInput): CalendarEventRef | null => {
  if (!eventId || !connectionId || !calendarId) {
    return null;
  }

  return { eventId, connectionId, calendarId };
};
